<header class="header flex align-items-center justify-content-between">
  <osf-breadcrumb />

  <div class="header-dropdown-button">
    @if (currentUser()) {
      <p-button
        class="link-btn-no-padding"
        icon="fas fa-chevron-down"
        iconPos="right"
        variant="text"
        severity="contrast"
        [label]="currentUser()?.fullName"
        (click)="menu.toggle($event)"
      />

      <p-menu appendTo="body" #menu [model]="items" popup>
        <ng-template #item let-item>
          <a class="p-menu-item-link w-8rem">{{ item.label | translate }}</a>
        </ng-template>
      </p-menu>
    } @else {
      <p-button [label]="'navigation.signIn' | translate" (onClick)="navigateToSignIn()"></p-button>
    }
  </div>
</header>
